import { createClient } from "@supabase/supabase-js";

const url =
    process.env.REACT_APP_SUPABASE_URL ||
    "https://rkhksruzbbeyvuquwedy.supabase.co";

const anonKey =
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    "sb_publishable_wbZfHrl-Ipwihdn8KnMUAg_FzfUk77x";

export const isSupabaseConfigured = Boolean(url && anonKey);

export const supabase = isSupabaseConfigured
    ? createClient(url, anonKey)
    : null;

export const SITE_IMAGES_BUCKET = "site-images";

export async function uploadSiteImage(file, folder = "images") {
    if (!supabase) throw new Error("Supabase não configurado");
    const ext = (file.name.split(".").pop() || "jpg").toLowerCase();
    const path = `${folder}/${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 8)}.${ext}`;
    const { error } = await supabase.storage
        .from(SITE_IMAGES_BUCKET)
        .upload(path, file, { upsert: true });
    if (error) throw error;
    const { data } = supabase.storage
        .from(SITE_IMAGES_BUCKET)
        .getPublicUrl(path);
    return data.publicUrl;
}

export function storagePathFromUrl(publicUrl) {
    const marker = `/object/public/${SITE_IMAGES_BUCKET}/`;
    const i = (publicUrl || "").indexOf(marker);
    return i === -1 ? null : publicUrl.slice(i + marker.length).split("?")[0];
}
